"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.submitNotifyMe = void 0;
const helpers_1 = require("../../helpers");
const agents_1 = require("../agents");
const course_1 = require("../course");
const formatDateFriendly_1 = require("../formatDateFriendly");
const mailchimp_1 = require("../mailchimp");
const sendEmail_1 = require("../sendEmail");
const submitNotifyMe = async (supabase, obj) => {
    const exists = await supabase
        .from("notify_me")
        .select(`*`)
        .eq("email", obj.email)
        .eq("course_id", obj.course_id)
        .eq("date", obj.date)
        .single();
    if (exists.data) {
        return {
            success: false,
            message: "Already Exists",
            data: null,
        };
    }
    if (obj.join_mailing_list && obj.email && obj.tags) {
        await (0, mailchimp_1.addToMailingList)(obj.email, obj.tags);
    }
    delete obj.tags;
    const { data, error } = await supabase
        .from("notify_me")
        .insert([obj])
        .select()
        .single();
    const course = await (0, course_1.getCourseById)(supabase, obj.course_id);
    const { data: existing_notifies, error: existing_notifies_error } = await supabase.from("notify_me").select(`*`).eq("course_id", obj.course_id);
    let agent = {};
    if (obj.agent_id) {
        agent = await (0, agents_1.getAgentById)(supabase, obj?.agent_id);
    }
    const existing_notifies_emails = !error ? existing_notifies : [];
    const support_notify_me_email_obj = {
        language_code: "en",
        data: {
            ...obj,
            date: (0, formatDateFriendly_1.formatDateFriendly)(obj.date),
            count: existing_notifies_emails.length || 0,
            agent: agent,
            course: {
                id: course.id,
                name: course.name.en,
            },
        },
        template_id: helpers_1.SUPPORT_NOTIFY_ME_EMAIL,
        cc_address: ["simon@golfsavers.com", "david@golfsavers.com"],
    };
    await (0, sendEmail_1.sendEmail)(support_notify_me_email_obj);
    return {
        success: true,
        message: "Successfully submitted",
        data: data,
    };
};
exports.submitNotifyMe = submitNotifyMe;
